import { Button, H3, Modal, P, lightTheme } from '@vgrubs/components';

/**
 * Confirmation shown before reverting a single item: reverting discards every
 * AI change on that item and restores it to the original menu, so it's gated
 * behind an explicit confirm (the split modal sits at z-index 95, this above it).
 */
export const RevertItemModal = ({
  isOpen,
  loading,
  closeModal,
  onConfirm,
}: {
  isOpen: boolean;
  loading: boolean;
  closeModal: () => void;
  onConfirm: () => void;
}) => {
  return (
    <Modal isOpen={isOpen} closeModal={closeModal} logo={false} zIndex={130}>
      <H3 $mb="24" $color={lightTheme.primary}>
        Restore item
      </H3>
      <P $mb="40">
        This restores the item to how it was before AI made any changes. The AI
        edits for this item will be discarded.
      </P>

      <Button
        $selected
        $w="100%"
        $mb="8"
        $loading={loading}
        onClick={onConfirm}
      >
        Restore to original
      </Button>

      <Button $selected $w="100%" $gray onClick={closeModal}>
        Cancel
      </Button>
    </Modal>
  );
};
